import { atom } from 'recoil';

export const atomImage = atom({ key: 'atomImage', default: '' });
export const atomResult = atom({ key: 'atomValue', default: { one: '', two: '' } });
